import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { compose } from 'redux'
import { Link } from 'react-router'
import './gp-web-signin.css'
import LoadingSvg from "../loading-svg";
import {
  CLEAR_SIGN_IN_ERROR,
  LOGIN_PENDING,
} from "../../actions";
import MoreDetails from "../sign-in/more-details";
import ErrorPopup from "../error-popup/error-popup";
import withSeparateAuthFlow from "../hoc/separate-auth-flow";

class GPWebSignin extends Component {
  state = {
    checkbox: true,
    error: false,
    email: '',
    password: '',
    uiPending: false,
  };

  emailHandler = (e) => {
    this.setState({
      email: e.target.value,
    })
  }

  passwordHandler = (e) => {
    this.setState({
      password: e.target.value,
    })
  }

  checkboxHandler = (e) => {
    this.setState({ checkbox: e.target.checked })
  }

  LogIn = (e) => {
    e.preventDefault()

    const { handleAction, redirectUri } = this.props
    const { email, password, checkbox } = this.state

    this.setState({ uiPending: true })

    handleAction(LOGIN_PENDING, {
      email: email,
      password: password,
      rememberPassword: checkbox,
      isRedirectFlow: !!redirectUri,
    })
  }

  signInErrorHandler = () => {
    const { handleAction, signInError } = this.props

    if (signInError !== '') {
      setTimeout(() => handleAction(CLEAR_SIGN_IN_ERROR), 30000)
      return signInError
    }
    return ''
  }

  alreadyRegisteredHandler = (options) => {
    const {
      signInError = '',
    } = options
    const filterError = [ signInError ].filter((value) => value.includes('You are already registered using'))

    if (!filterError.length) {
      return ''
    }

    // Regex used by type="email" from W3C - source https://emailregex.com/
    const emailRegex = new RegExp('[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)')
    const email = emailRegex.exec(filterError[0])

    if (!email) {
      return ''
    }

    const { t } = this.props

    return t('ERROR_ALREADY_REGISTERED', { email: email[0]})
  }

  render() {
    const {
      t,
      missingFields,
      clientId,
      provider,
      providerSecret,
      providerToken,
      handleAction,
    } = this.props
    const { uiPending, error, checkbox } = this.state
    const signInError = this.signInErrorHandler()
    const alreadyRegisteredError = this.alreadyRegisteredHandler({
      signInError,
    })

    const showLoadingSvg = uiPending && !signInError

    return (
      <div className="wrapper">
        
        <h1 className="title">{t("GP_LOGIN_TITLE")}</h1>

        {missingFields.length > 0
          && (
            <MoreDetails
              t={t}
              missingFields={missingFields}
              clientId={clientId}
              provider={provider}
              providerSecret={providerSecret}
              providerToken={providerToken}
              handleAction={handleAction}
            />
          )}

        {missingFields.length === 0
          && (
            <div className="modal-content">

              <form className="xs-relative" onSubmit={this.LogIn}>
                <input
                  type="email"
                  className={`sign-with email xs-fit xs-text-7 xs-regular text-input ${error && 'error-input'}`}
                  placeholder={t('YOUR_EMAIL')}
                  autoComplete="email"
                  onChange={this.emailHandler}
                  required
                  data-test-id="email"
                />
                <input
                  type="password"
                  className={`sign-with password xs-fit xs-text-7 xs-regular text-input ${error && 'error-input'}`}
                  placeholder={t('YOUR_PASSWORD')}
                  autoComplete="current-password"
                  onChange={this.passwordHandler}
                  required
                  data-test-id="password"
                />
                {error
                  && <span className="error-text">{t('SIGN_IN_VALIDATION_ERROR')}</span>}

                {alreadyRegisteredError
                  && <ErrorPopup t={t} error={alreadyRegisteredError} />}

                {signInError
                  && <ErrorPopup t={t} error={signInError} />}

                <button
                  className={`button-primary xs-border-none xs-pt1 xs-text-white xs-col-12 xs-text-7 ${showLoadingSvg && 'disabled'}`}
                  type="submit"
                  data-test-id="signin"
                >
                  {showLoadingSvg
                    ? <LoadingSvg />
                    : t('SIGN_IN_EM')}
                </button>

                <div className="sign-with chk-group xs-block">
                  <div className="xs-my4 xs-inline-block xs-text-black">
                    <label htmlFor="remember">
                      <input
                        type="checkbox"
                        className="check"
                        onChange={this.checkboxHandler}
                        name="remember"
                        id="remember"
                        checked={checkbox}
                      />
                      <span>{t('REMEMBER')}</span>
                    </label>
                  </div>
                  <Link
                    className="forgot xs-border-none xs-inline-block xs-float-right xs-mt4 xs-text-black cursor-pointer"
                    to={"/gp-web/forgot-password" + this.props.location.search}
                  >
                    {t('FORGOT_PASSWORD')}
                  </Link>
                </div>
              </form>

            </div>
          )}
      </div>
    )
  }
}

GPWebSignin.propTypes = {
  handleAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  signInError: PropTypes.string,
  missingFields: PropTypes.arrayOf(PropTypes.string),
  clientId: PropTypes.string,
  provider: PropTypes.string,
  providerSecret: PropTypes.string,
  providerToken: PropTypes.string,
  redirectUri: PropTypes.string,
}

GPWebSignin.defaultProps = {
  signInError: '',
  missingFields: [],
  clientId: '',
  provider: '',
  providerSecret: '',
  providerToken: '',
  redirectUri: null,
}

export default compose(withSeparateAuthFlow)(GPWebSignin);



// WEBPACK FOOTER //
// ./src/components/gp-web-login/gp-web-signin.js